import { ModelElementType } from '../enums/model-element-type.enum';
import { ConnectionSide } from '../enums/connection-side.enum';

export function hasConnector(
  type: ModelElementType,
  side: ConnectionSide
): boolean {
  if (type === ModelElementType.Central) return true;
  if (side === ConnectionSide.Left && type === ModelElementType.Right) return true;
  if (side === ConnectionSide.Right && type === ModelElementType.Left) return true;
  return false;
}
